var render = function render(){var _vm=this,_c=_vm._self._c;return (Array.isArray(_vm.listData))?_c('div',{staticClass:"molecule-popup-results"},_vm._l((_vm.listData),function(project,i){return _c('div',{key:i,staticClass:"building-list"},[_c('MoleculesProjectMoleculePopupResult',{attrs:{"project":project}})],1)}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }